import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '/src/api';
import {
    useForm,
    productGraphQLQueries,
    FormSearch
} from '/src/components';

const Search = () => {
    const navigate = useNavigate();
    const { data: products, isLoading, runQuery, setValues } = useQuery({
        query: productGraphQLQueries.getProducts({ pageSize: 5, currentPage: 1}),
        queryKey: ['search', 'magento_catalog_product', 'items'],
        isMethodPost: true,
    });
    const { data, handleChange } = useForm({ search: '' });

    const handleClearProducts = () => setValues({ data: '' });

    const handleSearch = e => {
        e.preventDefault();
        const queryParams = new URLSearchParams();

        queryParams.set('search', data.search);

        navigate({
            pathname: '/search',
            search: data.search ? `?${queryParams.toString()}` : ''
        })
    };

    useEffect(() => {
        let handle = null;

        if (data.search) {
            handle = setTimeout(
                () => runQuery({
                    variables: {
                        query: data.search,

                    }
                }),
                1000
            );
        } else if (products) {
            handleClearProducts();
        }

        return () => clearTimeout(handle);
    }, [data.search]);

    return (
        <FormSearch
            handleSearch={handleSearch}
            value={data.search}
            handleChange={handleChange}
            isLoading={isLoading}
            products={products}
            clearProducts={handleClearProducts}
        />
    );
};

export default Search;
